import { ErrorHandler } from './../utils/error-handler';
import { Printer } from './../masterdata/models/printer';
import { SelectItem } from 'primeng/api/selectitem';
import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/api';
import { NGSPrintRequest } from './ngs-print-request';
import { PrintPlateLabelService } from './print-plate-labels-service';

@Component({
  selector: 'app-print-plate-labels',
  templateUrl: './print-plate-labels.component.html',
  styleUrls: ['./print-plate-labels.component.css']
})
export class PrintPlateLabelsComponent implements OnInit{

  // Variable to control the dialog display
  display = false;

  // Message container for growl
  msgs: Message[] = [];

  // Quantity of required barcodes
  quantity = 1;

  // Plate type : maybe FLX or FA
  plateType: SelectItem[];

  // Selected plate
  slectedPlateType: string;

  // Printer list to display available printers
  printers: SelectItem[] = [];

  // Selected Printers
  selectedPrinter: Printer;

  // Store lab value from local storage
  localLab: any;

  // Print Request object
  ngsPrintRequest: NGSPrintRequest = new NGSPrintRequest;

  // Error handler object
  errorHandler: ErrorHandler = new ErrorHandler;

  //Default print lable type
  selectedPrintLable = 'PLATE_LABEL';

  labelPrefix: string;
  labelFrom: string;
  labelTo: string;

  constructor(  private printPlateLabelService: PrintPlateLabelService, private _printPlateLabelService: PrintPlateLabelService) {
  }

  ngOnInit() {
    // Initialize plate type selection items
    this.plateType = [
      { label: 'FLX Plate', value: 'FLX_QC_'},
      { label: 'FA Plate', value : 'FA_QC_'}
    ];
  }



  // Set dialog to be visible
  openDialog() {
    // Get local lab
    this.localLab = JSON.parse(localStorage.getItem('lab'));
    this.printers = [];
    // Get list of printers from MDM
    this.printPlateLabelService.getPrintersList(this.localLab.lab, true).subscribe(
      results => {
        if (!results) {
          return;
        }
        console.log('Printers List -> ', results.data);

        // If printer list not empty
        for ( let i = 0; i < results.data.length; i++ ) {
          this.printers.push( { label : results.data[i].name, value: results.data[i] });
        }
        this.selectedPrinter = null;
        this.slectedPlateType = null;
        this.labelPrefix = null;
        this.labelFrom = null;
        this.labelTo = null;
        this.selectedPrintLable = 'PLATE_LABEL';
      },
      error => {
        const errorMessage = error.error == null ? error.message :
                                          error.error.bbApiError == null ? error.message : error.error.bbApiError.message;
        const errorTitle = error.error == null ? error.name : error.error.bbApiError == null ? error.name : error.error.bbApiError.title;
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: errorTitle, detail: errorMessage });
      }
    );
    this.display = true;
  }

  // If required conditions for print are met, allow printing
  isPrintAllowed() {
    if ( this.selectedPrinter 
          && ( (this.slectedPlateType && (this.selectedPrintLable == "PLATE_LABEL") ) 
                  || (this.labelPrefix && (this.selectedPrintLable == "CUSTOM_LABEL")) 
              ) 
    ) {
      return true;
    }
    return false;
  }

  // Service call to print generate label print requests
  printLabelBarcodes() {
    console.log('quantity : ' + this.quantity);
    // Create request object
    this.ngsPrintRequest.numberOfBarcodes = this.quantity;
    this.ngsPrintRequest.plateType = this.slectedPlateType;
    this.ngsPrintRequest.printer = this.selectedPrinter;
    this.ngsPrintRequest.labelType = this.selectedPrintLable;
    this.ngsPrintRequest.cutsomPrefix = this.labelPrefix;
    this.ngsPrintRequest.customFrom = this.labelFrom;
    this.ngsPrintRequest.customTo = this.labelTo;

    // Service call to print-plate-labels-service
    this._printPlateLabelService.printPlateLabelBarcodes(this.ngsPrintRequest).subscribe(
      result => {
        if(result.data) {
          this.msgs.push({ severity: 'success', summary: 'Print Complete', detail: 'Requested Barcodes Printed' });
        } else {
          this.msgs.push({ severity: 'error', summary: 'Print Unsuccessful', detail: 'Requested Barcodes Could Not be Printed' });
        }
        this.quantity = 1;
      },
      error => {
        this.msgs.push(this.errorHandler.handleError(error));
      }
    );
  }

  isPlateLableEnabled():boolean {
    if(this.selectedPrintLable == "PLATE_LABEL"){
      return true;
    }
    else{
      return false;
    }
  }
}
